












import { cloneDeep, tap } from 'lodash';
import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import { ICanvasContentParameter, CampaignParameter, ICampaignParameter, ICanvasContent, CanvasContentParameter } from '@models';
import FormatVersionService from '../../../services/FormatVersionService';
import { Environment } from '../../../helpers/Environment';

@Component
export default class CampaignCanvasContentForm extends Vue {
  name = 'campaign-canvas-content-form';
  @Prop({ required: true, type: Object as () => ICanvasContent }) value: ICanvasContent;

  campaignParams: ICampaignParameter[] = [];

  assetsPath: string = "";
  environment: Environment = new Environment();

  @Watch('campaignParams')
  onCampaignParams() {
    const canvasParams = this.campaignParams.map<ICanvasContentParameter>(x => new CanvasContentParameter({
      canvasContentId: this.value.id,
      formatParameter: x.formatParameter,
      formatParameterId: x.formatParameterId,
      tag: x.tag,
      value: x.value,
      id: x.id,
      file: x.file
    }));

    const doUpdate = canvasParams
      .filter(x => this.value.parameters
        .find(y => x.tag == y.tag && x.value == y.value && x.formatParameterId == y.formatParameterId))
      .length < this.value.parameters.length;
    if (doUpdate) {
      this.$emit('input', tap(cloneDeep(this.value), v => v.parameters = canvasParams));
    }
  }

  @Watch('value.parameters')
  async onValueChanged() {
    if (this.value?.parameters?.length > 0) {
      this.campaignParams = this.value.parameters.map(canvasContentParam => new CampaignParameter({
        formatParameter: canvasContentParam.formatParameter,
        formatParameterId: canvasContentParam.formatParameterId,
        tag: canvasContentParam.tag,
        value: canvasContentParam.value,
        file: canvasContentParam.file,
        id: canvasContentParam.id,
        campaignId: canvasContentParam.campaignId
      }));
    }
    this.$emit('updated');
  }

  getParameterIndex(item: ICanvasContentParameter) {
    return this.value.parameters.findIndex(x => x.tag === item.tag);
  }

  get parameters() {
    return this.value.parameters.filter(x => x.formatParameter.isReplaceableValue).sort((l, r) => {
      if (l.formatParameter.description > r.formatParameter.description)
        return 1;
      else if (l.formatParameter.description < r.formatParameter.description)
        return -1;
      else
        return 0;
    });
  }

  async loadFormatVersion() {
    const response = await FormatVersionService.getSpecificFormatVersion(this.value.formatVersionId);
    if (response.status == 201 || response.status == 200) {
      return response.data;
    }
  }

  async findMissingParameters() {
    const formatVersion = await this.loadFormatVersion();
    const missingParameters = formatVersion.formatParameters
      .filter(formatParameter => formatParameter.isReplaceableValue && typeof (this.value.parameters
        .find(canvasContentParameter => canvasContentParameter.tag == formatParameter.tag)) === 'undefined')
      .map(formatParameter => new CanvasContentParameter({
        canvasContentId: this.value.id,
        formatParameter: formatParameter,
        formatParameterId: formatParameter.id,
        tag: formatParameter.tag,
        value: formatParameter.value
      }));


    return missingParameters.sort(
      (a, b) => {
        if (a.formatParameter.description.toLocaleLowerCase() < b.formatParameter.description.toLocaleLowerCase()) {
          return -1;
        }
        if (a.formatParameter.description.toLocaleLowerCase() > b.formatParameter.description.toLocaleLowerCase()) {
          return 1;
        }
        return 0;
      }
    );
  }

  @Watch('value.formatVersionId')
  async setupParams() {
    const missingParameters = await this.findMissingParameters();
    this.value.parameters = this.value.parameters.filter(x => x.formatParameter.isReplaceableValue).concat(missingParameters).sort((l, r) => {
      if (l.formatParameter.description > r.formatParameter.description)
        return 1;
      else if (l.formatParameter.description < r.formatParameter.description)
        return -1;
      else
        return 0;
    });
  }

  async created() {
    this.environment.GetEnvironmentVariables(["Environment:AssetPath"]).then(
      response => {
        this.assetsPath = response["Environment:AssetPath"];
      }
    )
    this.setupParams();
  }
}
